export default "__VITE_ASSET__D$nrqCbp__"